import { ListTemplateModel, TemplateModel, TGenericListReturn, TTemplateModel, TTemplateSharePayload } from "@cakemail-org/ui-components-v2"
import { TButtonRef } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"
import { MutableRefObject } from "react"


//Listing

export type TTemplatesStoredFilters = {
    [k: string]: TTemplatesFilters
}

export type TTemplatesFilters = {
    search?: string,
    tag?: string
    orderBy?: string,
    order?: "asc" | "desc",
    ownerFilter?: string
}



export type TTemplatesContainerContext = {
    templates?: TGenericListReturn<any>
    setTemplates?: Function
}

//Details

export type TTemplateDetails = {
    initTab?: ETemplateSubNav,
    isNewAccount?: boolean
}

export type TTemplateDetailContainerContext = {
    template: TemplateModel,
    templateRef: MutableRefObject<TemplateModel>,
    setTemplate: (template: TemplateModel) => void,
    updateTemplate: ({ }: TUpdateTemplate) => void,
    handleUnshare: Function,
    handleShare: ({ accounts, automatic, everyone }: TTemplateSharePayload) => Promise<void>
}

export type TUpdateTemplate = {
    data?: Partial<TTemplateModel>,
    btnRef?: TButtonRef,
    goToEdit?: boolean,
    noConfirmation?: boolean
}


export enum ETemplateSubNav {
    "details" = "details",
    "edit" = "edit",
    "sharing" = "sharing",
    "preview" = "preview"
}

